import React from "react";
import { useOrders } from "../context/OrdersContext";
import { useIp } from "../context/IpContext";
import DisplaySettings from "./DisplaySettings";

// Minimum and maximum number of visible dockets
const MIN_VISIBLE = 1;
const MAX_VISIBLE = 6;

// Minimum and maximum font size in percentage
const MIN_FONT_SIZE = 90;
const MAX_FONT_SIZE = 130;

export default function Settings({ onClose, type }) {
  const { ordersPerPage, setOrdersPerPage, fontSize, setFontSize } =
    useOrders();
  const { ipAddress, port } = useIp();

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2 style={styles.title}>— Settings —</h2>

        <div style={styles.divider} />

        <div style={styles.row}>
          <label style={styles.label}>Square</label>
          <button
            style={styles.actionButton}
            onClick={() =>
              (window.location.href = `http://${ipAddress}:${port}/authorize?type=${type}`)
            }
          >
            Connect to Square
          </button>
          {new URLSearchParams(window.location.search).get("connected") && (
            <span style={styles.connectedText}>✓ Connected</span>
          )}
        </div>

        <div style={styles.divider} />

        <div style={styles.row}>
          <label style={styles.label}>Dockets per page</label>
          <div style={styles.stepper}>
            <button
              style={styles.stepButton}
              onClick={() =>
                setOrdersPerPage((prev) => Math.max(MIN_VISIBLE, prev - 1))
              }
            >
              –
            </button>
            <span style={styles.stepValue}>{ordersPerPage}</span>
            <button
              style={styles.stepButton}
              onClick={() =>
                setOrdersPerPage((prev) => Math.min(MAX_VISIBLE, prev + 1))
              }
            >
              +
            </button>
          </div>
        </div>

        <div style={styles.row}>
          <label style={styles.label}>Font size</label>
          <div style={styles.stepper}>
            <button
              style={styles.stepButton}
              onClick={() =>
                setFontSize((prev) => Math.max(MIN_FONT_SIZE, prev - 10))
              }
            >
              –
            </button>
            <span style={styles.stepValue}>{fontSize}%</span>
            <button
              style={styles.stepButton}
              onClick={() =>
                setFontSize((prev) => Math.min(MAX_FONT_SIZE, prev + 10))
              }
            >
              +
            </button>
          </div>
        </div>

        <div style={styles.divider} />

        <div style={styles.row}>
          <label style={styles.label}>Displays</label>
        </div>
        <DisplaySettings />

        <div style={styles.divider} />

        <button style={styles.closeButton} onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.45)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    position: "relative",
    backgroundColor: "#f5f5dc",
    border: "3px solid #c9a84c",
    borderRadius: "6px",
    padding: "24px 28px 20px",
    minWidth: "320px",
    boxShadow: "5px 5px 0 rgba(0,0,0,0.25)",
    fontFamily: "'Courier New', Courier, monospace",
  },
  title: {
    margin: "0 0 16px",
    textAlign: "center",
    fontFamily: "'Courier New', Courier, monospace",
    letterSpacing: "4px",
    textTransform: "uppercase",
    fontSize: "1rem",
    color: "#3a3a3a",
  },
  divider: {
    borderTop: "2px dashed #c9a84c",
    margin: "14px 0",
  },
  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "12px",
    gap: "12px",
  },
  label: {
    fontWeight: "bold",
    fontSize: "0.85rem",
    letterSpacing: "1px",
    textTransform: "uppercase",
    color: "#3a3a3a",
    flex: 1,
  },
  stepper: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  stepButton: {
    width: "2em",
    height: "2em",
    border: "2px solid #c9a84c",
    borderRadius: "3px",
    background: "#fec871",
    fontFamily: "'Courier New', Courier, monospace",
    fontWeight: "bold",
    fontSize: "1rem",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  stepValue: {
    minWidth: "3em",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "0.95rem",
  },
  actionButton: {
    padding: "6px 14px",
    border: "2px solid #c9a84c",
    borderRadius: "3px",
    background: "#fec871",
    fontFamily: "'Courier New', Courier, monospace",
    fontWeight: "bold",
    fontSize: "0.8rem",
    letterSpacing: "1px",
    cursor: "pointer",
  },
  connectedText: {
    color: "#4a6741",
    fontWeight: "bold",
    fontSize: "0.85rem",
  },
  closeButton: {
    display: "block",
    width: "100%",
    padding: "10px",
    marginTop: "4px",
    background: "#d1cdba",
    border: "2px solid #b0ac99",
    borderRadius: "3px",
    fontFamily: "'Courier New', Courier, monospace",
    fontWeight: "bold",
    fontSize: "0.85rem",
    letterSpacing: "2px",
    textTransform: "uppercase",
    cursor: "pointer",
    boxShadow: "2px 2px 0 rgba(0,0,0,0.15)",
  },
};
